import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ manager }) =>
    present(
      repository
        .removeSubordinates(manager)
        .then((subordinateUuids) => ({ manager, subordinateUuids }))
        .catch(() => Promise.reject({ manager })),
    );
}

export type { Interactor };

export { createInteractor };
